import { Chip } from '@mui/material';
import { SCAN_LABEL_KEYS, type IScanLabel } from '../../shared/types.js';
import { colors } from '../styles/theme.js';

interface ScanStatusChipProps {
  scanLabel?: Pick<IScanLabel, 'key_name' | 'emoji' | 'label'> | null;
}

const COLOR_MAP: Record<string, string> = {
  [SCAN_LABEL_KEYS.SCAN_CREATED]:         colors.silver,
  [SCAN_LABEL_KEYS.TASK_CREATION_FAILED]: colors.scoreRed,
  [SCAN_LABEL_KEYS.TASK_QUEUED]:          colors.scoreYellow,
  [SCAN_LABEL_KEYS.TASK_PROCESSING]:      colors.scoreYellow,
  [SCAN_LABEL_KEYS.CMP_DETECTION]:        colors.scoreYellow,
  [SCAN_LABEL_KEYS.CMP_DETECTION_AI]:     colors.scoreYellow,
  [SCAN_LABEL_KEYS.TRACKING_CAPTURE]:     colors.scoreYellow,
  [SCAN_LABEL_KEYS.WORKFLOW_UNREACHABLE]: colors.scoreRed,
  [SCAN_LABEL_KEYS.COMPLETED]:            colors.scoreGreen,
  [SCAN_LABEL_KEYS.FAILED]:               colors.scoreRed,
  [SCAN_LABEL_KEYS.DATA_ANALYSING]:       '#7c3aed',
};

export default function ScanStatusChip({ scanLabel }: ScanStatusChipProps) {
  if (!scanLabel?.key_name) return null;

  const bgColor = COLOR_MAP[scanLabel.key_name] ?? colors.silver;
  const text = scanLabel.emoji ? `${scanLabel.emoji} ${scanLabel.label}` : scanLabel.label;

  return (
    <Chip
      label={text}
      size="small"
      sx={{
        bgcolor: bgColor,
        color: colors.white,
        fontWeight: 600,
        borderRadius: '50px',
        maxWidth: 220,
        '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
      }}
    />
  );
}
